import { useLayoutEffect } from "react";

const useScrollLock = (lock) => {
  useLayoutEffect(() => {
    if (lock) {
      const scrollY = window.scrollY ?? window.pageYOffset;
      const html = document.documentElement;
      const originalHtmlOverflow = html.style.overflow;
      html.style.overflow = "hidden";
      const originalBodyStyle = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        touchAction: document.body.style.touchAction,
      };
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.touchAction = "none";
      const mainElement = document.querySelector("main");
      let originalMainOverflow = "";
      if (mainElement) {
        originalMainOverflow = mainElement.style.overflow;
        mainElement.style.overflow = "hidden";
      }
      return () => {
        html.style.overflow = originalHtmlOverflow;
        Object.assign(document.body.style, originalBodyStyle);
        if (mainElement) mainElement.style.overflow = originalMainOverflow;
        window.scrollTo(0, scrollY);
      };
    }
  }, [lock]);
};

export default useScrollLock;
